import { render, staticRenderFns } from "./FullTopics.vue?vue&type=template&id=5ac5247c&scoped=true"
import script from "./FullTopics.vue?vue&type=script&lang=js"
export * from "./FullTopics.vue?vue&type=script&lang=js"
import style0 from "./FullTopics.vue?vue&type=style&index=0&id=5ac5247c&prod&scoped=true&lang=less"
import style1 from "./FullTopics.vue?vue&type=style&index=1&id=5ac5247c&prod&lang=less&scoped=true"
import style2 from "./FullTopics.vue?vue&type=style&index=2&id=5ac5247c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac5247c",
  null
  
)

export default component.exports